import React from 'react';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import compose from 'lodash/fp/compose';
import styles from './chart.module.css';
import { withTranslation, withUserPreferences } from 'components/hoc';
import { useDarkMode } from 'context/DarkModeContext';

const ExpenseChart = ({
  tr,
  dataList_1_year,
  dataList_3_year,
  dataList_5_year,
  dataList_100_year,
  income_dataList_1_year,
  income_dataList_3_year,
  income_dataList_5_year,
  income_dataList_100_year,
  fn,
  trObj,
}) => {
  console.log('dataList_100_year: ', dataList_100_year);
  const [interval, setInterval] = React.useState('year_1');
  const [categoryType, setCategoryType] = React.useState(
    Boolean(dataList_100_year.length) ? 'EXPENSE' : 'INCOME',
  );

  const { isDarkMode } = useDarkMode();

  const dataList =
    interval === 'year_1'
      ? dataList_1_year
      : interval === 'year_3'
      ? dataList_3_year
      : interval === 'year_5'
      ? dataList_5_year
      : interval === 'year_10'
      ? dataList_100_year
      : [];

  const income_dataList =
    interval === 'year_1'
      ? income_dataList_1_year
      : interval === 'year_3'
      ? income_dataList_3_year
      : interval === 'year_5'
      ? income_dataList_5_year
      : interval === 'year_10'
      ? income_dataList_100_year
      : [];

  const data_list = categoryType === 'EXPENSE' ? dataList : income_dataList;

  // console.log(JSON.stringify(data_list, null, 2));

  const options = {
    tooltips: {
      enabled: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: true,
      fontSize: 20,
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        labels: {
          // This more specific font property overrides the global property
          color: isDarkMode ? '#ffffff' : '#68696a',
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const data = {
    labels: data_list?.map((expense) => tr(expense?.financial_account_name)),

    datasets: [
      {
        label:
          categoryType === 'EXPENSE' ? '# Amount of Expsense' : '# Amount of Income',
        data: data_list?.map((expense) => expense?.amount?.toFixed(2)),
        type: 'doughnut',
        hoverOffset: 20,
        cutout: 60,
        radius: '100%',
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgb(54, 162, 235)',
          'rgb(255,140,0)',
          'rgb(255, 0, 0)',
          'rgb(64, 0, 255)',
          '#788087',
          '#E0B0FF	',
          '#002147',
          '#014421',
          'rgb(128,0,128)',
          'rgb(0,100,0)',
          '#3C1414',
          'rgb(205,92,92)',
          'rgb(139,69,19)',
          '#01995C',
          '#CA1F7B',
          'rgb(255, 255, 0)',
          '#4B0082',
          'rgb(0,139,139)',
        ],
      },
    ],
  };

  return (
    <>
      <div className={styles['interval_btn_container']}>
        <select
          value={interval}
          onChange={({ target }) => setInterval(target.value)}
          style={{
            height: 38,
            transition: 'all ease-in-out 300ms',
            borderRadius: 2,
            background: '#d5e4f7',
            color: '#4576b3',
            fontSize: 14,
            overflow: 'hidden',
            fontWeight: 500,
            padding: 10,
            border: 0,
          }}
        >
          <option value="year_1">{tr('1 year')}</option>
          <option value="year_3">{tr('3 years')}</option>
          <option value="year_5">{tr('5 years')}</option>
          <option value="year_10">{tr('10 years')}</option>
        </select>

        <select
          value={categoryType}
          onChange={({ target }) => setCategoryType(target.value)}
          style={{
            height: 38,
            transition: 'all ease-in-out 300ms',
            borderRadius: 2,
            background: '#d5e4f7',
            color: '#4576b3',
            fontSize: 14,
            overflow: 'hidden',
            fontWeight: 500,
            padding: 10,
            border: 0,
          }}
        >
          <option value="INCOME">{tr('INCOME')}</option>
          <option value="EXPENSE">{tr('EXPENSE')}</option>
        </select>
      </div>
      <div style={{ width: '100%', height: 300 }}>
        <Doughnut data={data} options={options} />
      </div>
    </>
  );
};

export default compose(withTranslation, withUserPreferences)(ExpenseChart);
